module.exports = __webpack_public_path__ + "img/fonasa.46611801.png";